/**
 * <LiveSessionsListSkeleton> — la forme de « Tous mes lives » pendant son premier chargement.
 *
 * Des jours, et sous chacun la carte-liste de ses séances : l'intitulé du jour, puis une ligne
 * par séance — `<SessionRowSkeleton timeOnly>`, l'heure et la ligne de la séance, la même forme à
 * toutes les largeurs que la vraie ligne. Trois jours de une ou deux séances : une semaine
 * ordinaire. La semaine du masteur, même page à sa voix, y pose sa ligne à lui (`row`).
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { CardList } from "../../molecules/CardList"
import { SessionRowSkeleton } from "../../molecules/SessionRow/SessionRowSkeleton"

/** Les séances de chaque jour montré. */
const DAYS = [2, 1, 2]

export type LiveSessionsListSkeletonProps = {
    /** La forme d'une ligne de séance. Défaut : `<SessionRowSkeleton timeOnly>`, celle du parent et de l'élève. */
    row?: React.ReactNode
}

export function LiveSessionsListSkeleton(props: LiveSessionsListSkeletonProps) {
    const { row = <SessionRowSkeleton timeOnly /> } = props
    return (
        <Stack gap="6">
            {DAYS.map((sessions, day) => (
                <Stack key={day} gap="3">
                    <Skeleton textSize="text-xs" width={120} />
                    <CardList>
                        {Array.from({ length: sessions }, (_, index) => (
                            <React.Fragment key={index}>{row}</React.Fragment>
                        ))}
                    </CardList>
                </Stack>
            ))}
        </Stack>
    )
}
